import { observer } from "mobx-react-lite";

import { BaseSelect } from "@/components/atoms";
import { ADMIN_COUNTRIES, findAdminCountry } from "@/config/adminCountries";
import { rootStore } from "@/store/RootStore";

const items = ADMIN_COUNTRIES.map(({ code, name }) => ({ id: code, name }));

/** The country the whole admin looks at. Sits in the top bar. */
const CountryFilter = observer(() => {
  const { countryCode } = rootStore.currencyFilter;

  return (
    <BaseSelect
      itemsList={items}
      value={countryCode}
      onChange={value => {
        const country = findAdminCountry(value);
        if (country) rootStore.currencyFilter.setCountry(country.code);
      }}
      className="w-[150px]"
      triggerProps={{
        "data-testid": "admin-country-filter",
        "aria-label": "Country",
      }}
    />
  );
});

export default CountryFilter;
